import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
import { faqs } from '../data/product';
import { trackCustom } from '../utils/tracking';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number>(0);
  return <section id="faq" className="border-b border-white/10 bg-ink-900" data-id="element-520" data-mp="1gitycb69z8mw">
      <div className="mx-auto max-w-[1400px] px-4 py-14 sm:px-6 lg:px-8 lg:py-20" data-id="element-521" data-mp="249g39tkzgcso">
        <h2 className="grit-headline text-[clamp(2.25rem,8vw,4rem)] font-extrabold uppercase text-offwhite" data-id="element-522" data-mp="24bk7kcmsndth">
          Straight <span className="text-grit-500" data-id="element-523" data-mp="1ujmq4o56zpmb">answers.</span>
        </h2>

        <ul className="mt-8 max-w-3xl border-t border-white/10" data-id="element-524" data-mp="1uhacuoadq3fl">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.q} className="border-b border-white/10" data-id="element-525" data-mp="2n6hc5phnqx1w" data-mpi={index}>
                <button type="button" onClick={() => {
              if (!isOpen) trackCustom('faq_opened', {
                question: faq.q
              });
              setOpenIndex(isOpen ? -1 : index);
            }} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-5 py-5 text-left text-offwhite transition-colors duration-150 ease-grit hover:text-grit-500 focus:outline-none focus-visible:ring-2 focus-visible:ring-grit-500" data-id="element-526" data-mp="2rz0m8ch4za1y">
                  <span className="font-display text-xl font-bold uppercase leading-tight sm:text-2xl" data-id="element-527" data-mp="1ohgf5r4rtfyq">{faq.q}</span>
                  {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-grit-500" aria-hidden="true" data-id="element-528" data-mp="1xkhijk294syp" /> : <PlusIcon className="h-5 w-5 shrink-0 text-grit-500" aria-hidden="true" data-id="element-529" data-mp="1slxwljnnrh6c" />}
                </button>
                <AnimatePresence initial={false} data-id="element-530" data-mp="3815o0eyagkv">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-531" data-mp="3udsveyotfr75">
                      <p className="max-w-2xl pb-6 text-[15px] leading-relaxed text-steel-400" data-id="element-532" data-mp="2c94k20lgkdrx">{faq.a}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}